import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
/* empty css                       */
const AppointmentSurvey = ({ className, labels, surveyUrl, onClick, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("appointment-survey", className) }, /* @__PURE__ */ React.createElement(Text, { variant: "body-head" }, labels.title), /* @__PURE__ */ React.createElement(Text, null, labels.description), /* @__PURE__ */ React.createElement(
  Button,
  {
    className: "appointment-survey__button",
    caption: labels.cta,
    href: surveyUrl,
    onClick,
    hrefTarget: "_blank"
  }
));
export {
  AppointmentSurvey as default
};
//# sourceMappingURL=AppointmentSurvey.js.map
